import { ResponseFormType } from "../../models";

export const addInsuranceOfferResponseFormData = (
  offerRequestId: string,
  offerResponse: ResponseFormType
) => {
  const formData = new FormData();

  formData.append("premiumAK", offerResponse.premiumAK);
  formData.append("premiumAO", offerResponse.premiumAO);
  formData.append("fullRegistrationCost", offerResponse.fullRegistrationCost);
  formData.append("insuredSum", offerResponse.insuredSum);
  offerResponse.note && formData.append("note", offerResponse.note);
  formData.append("offerRequestId", offerRequestId);
  offerResponse.file && formData.append("file", offerResponse.file);

  return formData;
};
